import i18n from 'live/services/i18n' // @ts-ignore: Unreachable code error
import { DropdownMenuItem } from 'plugin-liverig/shared/asset/styled'
import React, { useState } from 'react'
import styled from 'styled-components'
import ModelsConfigModal from './ModelsConfigModal'
import { ModelsConfigRegisterType } from './ModelsConfigTypes'

export default function ModelsConfigRegister({
    assetId,
    assetName
}: ModelsConfigRegisterType) {

    const [showModal, setShowModal] = useState(false)

    return (
        <>
            <RigProfileDropdownMenuItem
                key={'Models Configuration'}
                tabIndex={0}
                onClick={() => setShowModal(true)}
            >
                <span>
                    <i className="far fa-cog" />
                </span>
                <div>
                    <span>{i18n('Models Configuration')}</span>
                </div>
            </RigProfileDropdownMenuItem>

            {showModal && (
                <ModelsConfigModal
                    show={showModal}
                    setShow={setShowModal}
                    assetId={assetId}
                    assetName={assetName}
                />
            )}
        </>
    )
}

const RigProfileDropdownMenuItem = styled(DropdownMenuItem)`
    padding: 10px 20px;

    font-family: ${({ theme }): string => theme['font-semibold']};
    font-size: 14px;
    color: ${({ theme }): string => theme['brand-primary']};
    display: flex;

    &:hover {
        background-color: ${({ theme }): string => theme['gray-lighter']};
    }

    > span {
        flex-shrink: 0;
        flex-basis: 22px;
        text-align: center;
    }

    > div {
        flex: 1;
    }

    &:not(:first-child) {
        margin-top: 0px;
    }
`